// extracted by mini-css-extract-plugin
export default {"button":"Ka7l7_","link":"H1G3a5"};